import "css!js/file_viewer/components/preview.module.out.css";
export const container = "_container_1cr5w_1";
export const containerV2 = "_containerV2_1cr5w_35";
const classes = { "container": "_container_1cr5w_1", "containerV2": "_containerV2_1cr5w_35" };
export default classes;
//# sourceMappingURL=preview.module.css.preenvesnextjs.map
